// extracted by mini-css-extract-plugin
export default {"td":"a2UPj"};